import { render } from "./TimelapseVideoDetail.vue?vue&type=template&id=2dce7b54"
import script from "./TimelapseVideoDetail.vue?vue&type=script&lang=js"
export * from "./TimelapseVideoDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__